import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import About from 'features/UserMenu/features/About/index.web';
import Accessibility from 'features/UserMenu/features/Accessibility/index.web';
import Account from 'features/UserMenu/features/Account/index.web';
import Places from 'features/UserMenu/features/Places/index.web';
import { Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

const userMenuTabs = [
  { option: 'Account', Component: Account },
  { option: 'Places', Component: Places },
  { option: 'Accessibility', Component: Accessibility },
  { option: 'About', Component: About },
];

const UserMenu = () => {
  const [searchParams] = useSearchParams();

  const requestedTab = searchParams.get('tab')?.toLowerCase();
  const Tab =
    userMenuTabs.find(({ option }) => option.toLowerCase() === requestedTab)?.Component ?? Account;

  return (
    <Container fluid className="d-flex flex-column pb-3">
      {/* header */}
      <div className="d-none d-lg-block flex-shrink-0">
        <TabsHeader options={userMenuTabs} />
      </div>
      <div className="d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader options={userMenuTabs} />
      </div>
      {/* content */}
      <div className="px-2 px-md-3 overflow-x-hidden">
        {Tab === Places ? <Places search={searchParams.get('search') || ''} /> : <Tab />}
      </div>
    </Container>
  );
};

export default UserMenu;
